import { render, staticRenderFns } from "./SocietyMatchesRequestDetails.vue?vue&type=template&id=bce4cfce&scoped=true"
import script from "./SocietyMatchesRequestDetails.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce4cfce",
  null
  
)

export default component.exports